<template>
    <div id="content">
        <loader></loader>
        <div class="top">
            <div class="header">
                <h1>{{customer.company || "Ajout d'un client"}} </h1>
                <div class="pageOptions">
                    <btn text="Ajouter un motif" ico="add" @click="addReason"></btn>
                    <btn text="Enregistrer" ico="valide" @click="saveCustomer" v-if="$store.getters.hasPerm('customer:add/edit')"></btn>
                    <btn ico="times" color="red" @click="cancel" v-if="$store.getters.hasPerm('customer:add/edit')"></btn>
                </div>
            </div>
        </div>
        <div class="double">
            <form class="large" action="" method="post">
                <div class="mb">
                    <label for="nomSociete">Nom de la structure</label>
                    <input type="text" v-model="customer.company" id="nomSociete">
                </div>
                <div class="line">
                    <div>
                        <label for="typeStructure">Type de structure</label>
                        <input type="text" v-model="customer.company_type" id="typeStructure">
                    </div>
                    <div>
                        <label for="roleStructure">Role de la structure</label>
                        <input type="text" v-model="customer.company_role" id="roleStructure">
                    </div>
                </div>
                <div class="mb">
                    <label for="rattachementSiege">Rattachement siege</label>
                    <input type="text" v-model="customer.company_headquarters" id="rattachementSiege">
                </div>
                <div class="mb">
                    <label for="adresse1" >Adresse 1</label>
                    <input type="text" v-model="customer.address_1" id="adresse1">
                </div>
                <div class="line">
                    <div>
                        <label for="adresse2" >Adresse 2</label>
                        <input type="text" v-model="customer.address_2" id="adresse2">
                    </div>
                    <div>
                        <label for="adresse3">Adresse 3</label>
                        <input type="text" v-model="customer.address_3" id="adresse3">
                    </div>
                </div>
                <div class="line">
                    <div>
                        <label for="codePostal">Code Postal</label>
                        <input type="text" v-model="customer.postal_code"  id="codePostal">
                    </div>
                    <div>
                        <label for="ville">Ville</label>
                        <input type="text" v-model="customer.city"  id="ville">
                    </div>
                </div>
                <div class="line">
                    <div>
                        <label for="telephone">Téléphone Principale</label>
                        <input type="tel"  id="telephone" v-model="customer.phone">
                    </div>
                    <div>
                        <label for="mail">Mail</label>
                        <input type="text" v-model="customer.mail" id="mail">
                    </div>
                    <div>
                        <label for="fax">Fax</label>
                        <input type="text" v-model="customer.fax" id="fax">
                    </div>
                </div>
                <div class="line">
                    <div>
                        <label for="observation">Observations</label>
                        <textarea id="observation" v-model="customer.observation"></textarea>
                    </div>
                </div>
            </form>
            <div class="table-responsive">
                <table>
                    <thead class="noOptions">
                    <tr>
                        <th></th>
                        <th>Motifs d'appel</th>
                        <th>Options</th>
                    </tr>
                    </thead>
                    <draggable handle=".drag" v-model="customerReasons" tag="tbody">
                        <tr v-for="(reason,key) in customerReasons">
                            <td class="drag"><svg><use xlink:href="#icon-drag"></use></svg></td>
                            <td>
                                <model-list-select v-model="customerReasons[key]"
                                    :list="reasons"
                                    option-value="id"
                                    option-text="label"
                                    placeholder="Sélectionner une raison">

                                </model-list-select>
                            </td>
                            <td class="tableOptions">
                                <div @click="delReason(reason,key)" title="Supprimer le motif d'appel">
                                    <svg class="option" ><use xlink:href="#icon-delete"></use></svg>
                                </div>
                            </td>
                        </tr>
                    </draggable>
                </table>
            </div>
        </div>
    </div>

</template>

<script>
    import Btn from "@/components/Btn";
    import axios from 'axios';
    import tools from '../config.ts';
    import draggable from 'vuedraggable'
    import ModelListSelect from "vue-search-select/src/lib/ModelListSelect";
    import Loader from "@/components/Loader";

    export default {
        name: "Customer",
        components: {ModelListSelect, Btn,draggable,Loader},
        data(){
            return {
                customer:{},
                reasons:[],
                customerReasons:[],

                customer_id : 0,
            }
        },
        methods:{
            loadCustomer(){

                if(!this.customer_id){

                    tools.loader(false);
                    return;
                }

                axios.get(tools.api("customer/"+this.customer_id),tools.headerGET())
                    .then((response)=> {
                        this.customer = response.data;

                        tools.loader(false);
                    })
            },
            loadReasons(){

                axios.get(tools.api("reasons"),tools.headerGET())
                    .then((response)=> {
                        this.reasons = response.data.filter((reason) => reason.active === '1');

                        if(this.reasons.length <= 0){
                            this.reasons.push({
                                id : 0,
                                label : "Il n'y a aucun motif d'appel"
                            })
                        }
                    })

                if(!this.customer_id){
                    return;
                }

                axios.get(tools.api("reasons/customer/"+this.customer_id),tools.headerGET())
                    .then((response)=> {
                        this.customerReasons = response.data;
                    })
            },
            delReason(reason,key){
                tools.popup("confirm",{
                    message:"Voulez-vous vraiment supprimé ce motif d'appel '"+reason.label+"'?",
                    success:() => {
                        return this.customerReasons = this.customerReasons.filter((cr,k) => k !== key);
                    }
                })
            },
            saveCustomer(){

                let url = "customer";
                if(this.customer_id){
                    url += "/"+this.customer_id
                }

                let data = this.customer;
                data.reasons = this.customerReasons.map(reason => reason.id);

                tools.loader(true);
                axios.post(tools.api(url),tools.toPOST(data),tools.headerPOST())
                    .then((response) => {
                        tools.loader(false);
                        if(!tools.isSuccessResponse(response)){
                            return tools.popup("valid",{
                                title:"Erreur",
                                message:"Erreur lors de l'enregistrement du client<br/><br/>Détail de l'erreur : "+tools.parseError(error)
                            })
                        }

                        this.$router.push("/customers");
                    })
                    .catch((error) => {

                        tools.loader(false);

                        tools.popup("valid",{
                            title:"Erreur",
                            message:"Erreur lors de l'enregistrement du client.<br/><br/>Détail de l'erreur : "+tools.parseError(error)
                        })
                    })
            },
            cancel (){
                tools.popup("confirm",{
                    title:"Confirmation",
                    message :"Voulez-vous vraiment annuler les modifications ?",
                    success : () => {
                        this.$router.push("/customers");
                    }
                })
            },
            addReason(){
                this.customerReasons.push({});
            }
        },
        watch:{
            $route() {
                this.customer_id = this.$route.params.id;
                this.loadCustomer()
            }
        },
        mounted() {

            if(!this.$store.getters.hasPerm('customer:add/edit')){
                return this.$router.back();
            }

            tools.loader(true);

            this.$store.commit("onEditMode",true);

            this.customer_id = this.$route.params.id;

            this.loadCustomer();
            this.loadReasons();
        }
    }
</script>
